import { avatarModelForPlayer } from './avatarModel';

export function normalizeUserId(userId) {
  return userId === null || userId === undefined ? '' : String(userId);
}

export function buildSeatPresentation({
  seat,
  currentUserId,
  activeUserId,
  roomStatus,
  recentActionUserIds = [],
  showdownUserIds = []
} = {}) {
  if (!seat?.player) {
    return {
      mode: 'empty',
      tappable: roomStatus === 'playing',
      avatar: avatarModelForPlayer(null),
      showCards: false
    };
  }

  const player = seat.player;
  const playerUserId = normalizeUserId(player.userId);
  const currentUserIdValue = normalizeUserId(currentUserId);
  const activeUserIdValue = normalizeUserId(activeUserId);
  const recentActionUserIdValues = recentActionUserIds.map(normalizeUserId);
  const showdownUserIdValues = showdownUserIds.map(normalizeUserId);

  if (playerUserId === currentUserIdValue) {
    return {
      mode: 'hero',
      tappable: false,
      avatar: avatarModelForPlayer(player),
      showCards: true
    };
  }

  if (
    playerUserId === activeUserIdValue
    || recentActionUserIdValues.includes(playerUserId)
    || showdownUserIdValues.includes(playerUserId)
  ) {
    return {
      mode: 'focus',
      tappable: false,
      avatar: avatarModelForPlayer(player),
      showCards: false
    };
  }

  return {
    mode: 'compact',
    tappable: false,
    avatar: avatarModelForPlayer(player),
    showCards: false
  };
}
